import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FaUser } from "react-icons/fa6";
import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import config from "../../config";
import SuccessPopup from "../../components/common/SuccessPopup";
import ErrorPopup from "../../components/common/ErrorPopup";
import ConfirmPopup from "../../components/common/ConfirmPopup";
import { LuPencilLine, LuUserX, LuUpload } from "react-icons/lu";
import { IoIosArrowBack } from "react-icons/io";
import { GrNotification } from "react-icons/gr";
import { VscChevronRight } from "react-icons/vsc";
import Header from "../../components/common/Header";
import "./AddEmployee.css";
import "react-datepicker/dist/react-datepicker.css";
import { BANK_LIST } from "../constants/dropdownConstants";
import TerminationPopup from "../separation/TerminationPopup";
import ExitPopup from "../separation/ExitPopup";

const AddEmployee = ({
  onCancel,
  onSuccess,
  selectedEmployee,
  fetchEmployees,
  convertData,
  fromSeparation,
}) => {
  const isViewModeInitial = !!selectedEmployee;
  const [isViewMode, setIsViewMode] = useState(isViewModeInitial);
  const formikRef = useRef(null);
  const [employeeDetail, setEmployeeDetail] = useState(null);
  const [userDetails, setUserDetails] = useState({
    name: "",
    role: "",
    token: "",
  });
  const [departments, setDepartments] = useState([]);
  const [selectedClient, setSelectedClient] = useState(0);
  const [workTypes, setWorkTypes] = useState([]);
  const [shiftTimings, setShiftTimings] = useState([]);
  const [shiftTypes, setShiftTypes] = useState([]);
  const [jobRole, setjobrole] = useState([]);
  const [clients, setClients] = useState([]);
  const [contractDuration, setContractDuration] = useState([]);
  const [bands, setBands] = useState([]);
  const [qualification, setQualification] = useState([]);
  const [subVendors, setSubVendors] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [showDeleteConfirmPopup, setShowDeleteConfirmPopup] = useState(false);
  // Separation-specific state
  const [assets, setAssets] = useState([]);
  const [assetOptions, setAssetOptions] = useState([]);
  const [showTerminateModal, setShowTerminateModal] = useState(false);
  const [showExitModal, setShowExitModal] = useState(false);
  const [contractFile, setContractFile] = useState(null);


  useEffect(() => {
    const token = localStorage.getItem("Authorization") || "";
    const firstName = localStorage.getItem("firstName") || "";
    const lastName = localStorage.getItem("lastName") || "";
    const role = localStorage.getItem("role")?.toUpperCase() || "GUEST";
    const orgId = localStorage.getItem("orgId") || "";
    const orgName = localStorage.getItem("companyName") || "";

    setUserDetails({
      name: `${firstName} ${lastName}`.trim(),
      role,
      token,
      orgId,
    });
  }, []);
  useEffect(() => {
    fetchAssetOptions();
  }, []);

  const fetchAssetOptions = async () => {
    try {
      const token = localStorage.getItem("Authorization");
      const orgId = localStorage.getItem("orgId");
      if (!token || !orgId) return;

      const res = await fetch(
        `${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${orgId}?configType=Asset`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (res.ok) {
        const data = await res.json();
        const activeOptions = data.filter((item) => item.isActive);
        setAssetOptions(activeOptions);
      }
    } catch (err) {
      console.error("Failed to fetch asset options:", err);
    }
  };

  // Fetch employee details when in view/edit mode
  useEffect(() => {
    if (!selectedEmployee || !selectedEmployee.employeeId) return;

    const token = localStorage.getItem("Authorization");
    const employeeId = selectedEmployee.employeeId;

    fetch(
      `${config.API_BASE_URL}${config.GET_EMPLOYEE_DETAIL_ENDPOINT}${employeeId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        const employeeData = data.body || data.data || data;
        // Store full detail data for dropdown matching and initialValues
        setEmployeeDetail(employeeData);

        // Update basic states to trigger cascading dropdown APIs
        if (employeeData.clientKey) setSelectedClient(employeeData.clientKey);
        if (employeeData.country) setSelectedCountry(String(employeeData.country));
        if (employeeData.state) setSelectedState(String(employeeData.state));

        // Update assets array
        if (employeeData.assets && Array.isArray(employeeData.assets)) {
          setAssets(employeeData.assets);
        } else {
          setAssets([]);
        }

        // Note: Individual field updates are now handled by initialValues + enableReinitialize
      })
      .catch((err) => {
        console.error("Error fetching employee details:", err);
      });
  }, [selectedEmployee?.employeeId]);

  useEffect(() => {
    if (!selectedClient) return;

    const token = localStorage.getItem("Authorization");
    const orgId = localStorage.getItem("orgId") || "6";

    fetch(
      `${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${orgId}?configType=ShiftTiming`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setShiftTimings(data?.data || data);
      })
      .catch((err) => {
        console.error("ShiftTiming API Error:", err);
      });
  }, [selectedClient]);

  const blankInitialValues = {
    client: "",
    employeeName: "",
    dob: "",
    phoneNumber: "+91 ",
    emailAddress: "",
    maritalStatus: "",
    aadharNumber: "",
    uanNumber: "",
    gender: "",
    address: "",
    city: "",
    district: "",
    state: "",
    country: "",
    pinCode: "",
    shiftType: "",
    shiftTiming: "",
    subVendor: "",
    jobRole: "",
    department: "",
    workSite: "",
    dateOfJoining: "",
    workType: "",
    qualification: "",
    skills: "",
    experience: "",
    experienceMonths: "",
    contractDuration: "",
    workPermitNumber: "",
    workPermitValidDate: "",
    visaNumber: "",
    visaValidityDateTill: "",
    passportNumber: "",
    passportValidityDateTill: "",
    emergencyContactName: "",
    emergencyContactNumber: "+91 ",
    bankName: "",
    accountHolderName: "",
    accountNumber: "",
    branch: "",
    ifsc: "",
    upiId: "",
    ipNumber: "",
    band: "",
    jobrole: "",
    salary: "",
    clientEmployeeId: "",
  };

  // Helper to safely parse DD-MM-YYYY date strings from API
  const parseDDMMYYYYToDisplay = (str) => {
    if (!str) return "";
    if (/^\d{2}-\d{2}-\d{4}$/.test(str)) return str; // Already DD-MM-YYYY
    const d = new Date(str);
    if (!isNaN(d.getTime())) {
      return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
    }
    return "";
  };

  // Map data from Detail API or selected prop into form fields
  const getInitialValues = () => {
    const data = employeeDetail || selectedEmployee;

    if (data) {
      const formatPhone = (phone) => {
        if (!phone) return "+91 ";
        if (phone.startsWith("+91") && !phone.startsWith("+91 ")) {
          return "+91 " + phone.slice(3).trim();
        }
        return phone;
      };

      return {
        client: data.clientKey || "",
        employeeName: data.employeeName || "",
        dob: parseDDMMYYYYToDisplay(data.dateOfBirth),
        phoneNumber: formatPhone(data.phoneNumber),
        emailAddress: data.emailAddress || "",
        maritalStatus: data.maritalStatus || "",
        aadharNumber: data.aadharNumber || "",
        uanNumber: data.uanNumber || "",
        gender:
          data.gender === "Male" || data.gender === "MALE"
            ? "MALE"
            : data.gender === "Female" || data.gender === "FEMALE"
              ? "FEMALE"
              : data.gender === "Other" || data.gender === "OTHER"
                ? "OTHER"
                : "",
        address: data.address || "",
        city: data.city || "",
        district: String(data.district || ""),
        state: String(data.state || ""),
        country: String(data.country || ""),
        pinCode: String(data.pincode || ""),
        shiftType: data.shiftType || "",
        shiftTiming: data.shiftTiming || "",
        subVendor: data.subVendorName || "",
        jobRole: data.jobRole || "",
        department: String(data.departmentId || ""),
        workSite: data.workSite || "",
        dateOfJoining: parseDDMMYYYYToDisplay(data.dateOfJoin),
        workType: data.workType || "",
        qualification: data.qualification || "",
        skills: data.skills || "",
        experience: String(data.experienceYear || ""),
        experienceMonths: String(data.experienceMonth || ""),
        contractDuration: data.contractDuration || "",
        workPermitNumber: data.workPermitNumber || "",
        workPermitValidDate: parseDDMMYYYYToDisplay(data.workPermitValidDate),
        visaNumber: data.visaNumber || "",
        visaValidityDateTill: parseDDMMYYYYToDisplay(data.visaValidDate),
        passportNumber: data.passportNumber || "",
        passportValidityDateTill: parseDDMMYYYYToDisplay(data.passportValidDate),
        emergencyContactName: data.emergencyContactName || "",
        emergencyContactNumber: formatPhone(data.emergencyContactNumber),
        bankName: data.bankName || "",
        accountHolderName: data.accountHolderName || "",
        accountNumber: data.bankAccountNumber || "",
        branch: data.branch || "",
        ifsc: data.ifsc || "",
        upiId: data.upiId || "",
        ipNumber: data.ipNumber || "",
        band: String(data.bandId || ""),
        jobrole: String(data.roleId || ""),
        salary: String(data.salary || ""),
        clientEmployeeId: data.employeeCode?.replace("EMP-", "") || "",
      };
    }

    if (convertData) {
      return {
        ...blankInitialValues,
        employeeName: convertData.name,
        dob: parseDDMMYYYYToDisplay(convertData.dob),
        aadharNumber: convertData.aadhar,
        uanNumber: convertData.uan,
        emailAddress: convertData.email,
        phoneNumber: convertData.phone,
        gender:
          convertData.gender === "Male" || convertData.gender === "MALE"
            ? "MALE"
            : convertData.gender === "Female" || convertData.gender === "FEMALE"
              ? "FEMALE"
              : convertData.gender === "Other" || convertData.gender === "OTHER"
                ? "OTHER"
                : "",
        address: convertData.addressLine1,
        city: convertData.city,
        district: convertData.district,
        state: convertData.state,
        country: convertData.country,
        pinCode: convertData.pinCode,
        jobRole: convertData.jobRole,
        subVendor: convertData.subVendorName,
      };
    }

    return blankInitialValues;
  };

  const initialValues = getInitialValues();

  const validationSchema = Yup.object({
    employeeName: Yup.string()
      .required("Employee Name is required.")
      .max(100, "Employee Name must not exceed 100 characters."),

    phoneNumber: Yup.string()
      .matches(
        /^\+91\s\d{10}$/,
        "Phone number must be in format +91 XXXXXXXXXX"
      )
      .required("Phone Number is required."),

    emailAddress: Yup.string()
      .email("Enter a valid email.")
      .test(
        "no-uppercase",
        "Email should not contain uppercase letters.",
        (value) => !value || value === value.toLowerCase()
      )
      .required("Email address is required."),

    workSite: Yup.string()
      .required("Work site is required")
      .max(100, "Work site should not exceed 100 characters"),

    dob: Yup.string()
      .matches(
        /^(0[1-9]|[12][0-9]|3[01])-(0[1-9]|1[0-2])-\d{4}$/,
        "Date must be in DD-MM-YYYY format"
      )
      .test("age-check", "Employee must be at least 18 years old.", (value) => {
        if (!value) return true;
        const parts = value.split("-");
        if (parts.length !== 3) return false;
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);
        const dobDate = new Date(year, month, day);
        if (isNaN(dobDate.getTime())) return false;

        const today = new Date();
        let age = today.getFullYear() - dobDate.getFullYear();
        const m = today.getMonth() - dobDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < dobDate.getDate())) {
          age--;
        }
        return age >= 18;
      })
      .required("Date of Birth is required"),

    visaNumber: Yup.string()
      .max(20, "Visa number should not exceed 20 characters")
      .nullable(),

    city: Yup.string()
      .required("City is required")
      .max(50, "City should not exceed 50 characters"),

    accountNumber: Yup.string()
      .trim()
      .required("Account Number is required.")
      .matches(/^[0-9]{9,18}$/, "Account Number must be 9 to 18 digits"),
    clientEmployeeId: Yup.string()
      .required("Client Employee ID is required.")
      .max(50, "Client Employee ID should not exceed 50 characters"),
    passportNumber: Yup.string()
      .matches(
        /^[A-Za-z0-9]{9}$/,
        "Passport number must be exactly 9 alphanumeric characters"
      )
      .nullable()
      .notRequired(),

    address: Yup.string()
      .required("Address is required.")
      .max(200, "Address cannot exceed 200 characters."),

    district: Yup.string()
      .required("District is required."),

    state: Yup.string()
      .required("State is required."),

    pinCode: Yup.string()
      .matches(/^\d{6}$/, "PIN Code must be 6 digits")
      .required("PIN Code is required."),

    country: Yup.string()
      .required("Country is required."),

    aadharNumber: Yup.string()
      .matches(/^\d{12}$/, "Aadhar Number must be 12 digits")
      .required("Aadhar Number is required."),

    bankName: Yup.string()
      .required("Bank Name is required."),

    accountHolderName: Yup.string()
      .required("Account Holder Name is required.")
      .max(100, "Account Holder Name should not exceed 100 characters"),

    branch: Yup.string()
      .required("Branch is required.")
      .max(100, "Branch should not exceed 100 characters"),

    ifsc: Yup.string()
      .required("IFSC is required.")
      .matches(
        /^[A-Z]{4}0[A-Z0-9]{6}$/,
        "Enter valid IFSC code"
      ),
    emergencyContactName: Yup.string()
      .required("Emergency Contact Name is required.")
      .max(100, "Emergency Contact Name should not exceed 100 characters"),

    emergencyContactNumber: Yup.string()
      .matches(
        /^\+91\s\d{10}$/,
        "Emergency Contact Number must be in format +91 XXXXXXXXXX"
      )
      .required("Emergency Contact Number is required."),
    jobrole: Yup.string().required("Job Role is required."),
    band: Yup.string().required("Band is required."),
    upiId: Yup.string()
      .required("UPI ID is required.")
      .matches(
        /^[a-zA-Z0-9.\-_]{2,256}@[a-zA-Z]{2,64}$/,
        "Enter valid UPI ID"
      ),
    client: Yup.string().required("Client is required."),
    subVendor: Yup.string().required("Sub Vendor is required."),
    jobRole: Yup.string().required("Job Role is required."),
    department: Yup.string().required("Department is required."),
    dateOfJoining: Yup.string().required("Date of Joining is required."),
    workType: Yup.string().required("Work Type is required."),
    qualification: Yup.string().required("Qualification is required."),
    skills: Yup.string().required("Skills are required."),
    contractDuration: Yup.string().required("Contract Duration is required."),
    gender: Yup.string().required("Gender is required."),
    uanNumber: Yup.string()
      .required("UAN Number is required.")
      .matches(/^\d{12}$/, "UAN Number must be 12 digits"),
    shiftType: Yup.string().required("Shift Type is required."),
    shiftTiming: Yup.string().required("Shift Timing is required."),
  });

  // Utility functions for payload mapping
  // const toISODate = (dateStr) => {
  //   if (!dateStr) return null;

  //   const [day, month, year] = dateStr.split("/");
  //   return `${year}-${month}-${day}`;
  // };

  const removePhoneSpace = (phone) => phone.replace(/\s/g, "");

  const getValueFromList = (list, id) =>
    list.find((i) => i.id === Number(id))?.values || "";



  const handleDelete = () => {
    if (!selectedEmployee) {
      setErrorMessage("No employee selected to delete.");
      return;
    }
    setShowDeleteConfirmPopup(true);
  };

  const handleDeleteConfirm = async () => {
    setShowDeleteConfirmPopup(false);

    if (!selectedEmployee) {
      setErrorMessage("No employee selected to delete.");
      return;
    }

    const token = localStorage.getItem("Authorization");
    const employeeId = selectedEmployee.employeeId;

    try {
      const response = await fetch(
        `${config.API_BASE_URL}${config.DELETE_EMPLOYEE_ENDPOINT}${employeeId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        setSuccessMessage("Employee deleted successfully!");
        if (fetchEmployees) {
          fetchEmployees();
        }
      } else {
        setErrorMessage("Failed to delete employee.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      setErrorMessage("An error occurred while deleting employee.");
    }
  };

  const handleTerminate = async () => {
    if (!selectedEmployee) {
      setErrorMessage("No employee selected to terminate.");
      return;
    }

    setShowConfirmPopup(false);

    const token = localStorage.getItem("Authorization");
    const orgId = localStorage.getItem("orgId");
    const values = formikRef.current?.values || {};

    const payload = {
      orgKey: Number(orgId),
      clientKey: Number(values.client) || Number(selectedEmployee.clientKey) || 0,
      emailAddress: values.emailAddress || selectedEmployee.emailAddress || "",
      status: "InActive",
    };

    try {
      const response = await fetch(
        `${config.API_BASE_URL}${config.UPDATE_EMPLOYEE_STATUS_ENDPOINT}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        setSuccessMessage("Employee terminated successfully!");
        if (fetchEmployees) {
          setTimeout(() => {
            fetchEmployees();
            onCancel();
          }, 1500);
        }
      } else {
        setErrorMessage("Failed to terminate employee.");
      }
    } catch (error) {
      console.error("Termination error:", error);
      setErrorMessage("An error occurred while terminating the employee.");
    }
  };

  const parseDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return null;
    const parts = dateStr.includes("-") ? dateStr.split("-") : dateStr.split("/");
    if (parts.length !== 3) return null;
    const d = new Date(parts[2], parts[1] - 1, parts[0]);
    return isNaN(d.getTime()) ? null : d;
  };

  const formatDate = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    const token = localStorage.getItem("Authorization");
    const orgId = localStorage.getItem("orgId");
    const isEdit = !!selectedEmployee;
    const employeeId = selectedEmployee?.employeeId;
    const payload = {
      orgKey: Number(orgId),
      clientKey: Number(values.client),

      employeeName: values.employeeName,
      dateOfBirth: values.dob,

      phoneNumber: removePhoneSpace(values.phoneNumber),
      emailAddress: values.emailAddress,

      maritalStatus: values.maritalStatus,
      aadharNumber: values.aadharNumber,
      uanNumber: values.uanNumber,

      gender:
        values.gender === "MALE"
          ? "Male"
          : values.gender === "FEMALE"
            ? "Female"
            : "Other",

      address: values.address,
      city: values.city,
      district:
        districts.find((d) => d.code === values.district)?.name ||
        values.district,
      state: states.find((s) => s.code === values.state)?.name || values.state,
      country:
        countries.find((c) => c.code === values.country)?.name ||
        values.country,

      pincode: Number(values.pinCode),

      shiftType: values.shiftType,
      shiftTiming: values.shiftTiming,

      clientName:
        clients.find((c) => c.clientKey === Number(values.client))?.name || "",

      subVendorName: values.subVendor,

      jobRole: values.jobRole,
      departmentId: Number(values.department),
      department: departments.find((d) => String(d.id) === String(values.department))?.values || values.department,
      workType: values.workType,
      qualification: values.qualification,
      contractDuration: values.contractDuration,

      workSite: values.workSite,
      dateOfJoin: values.dateOfJoining,
      skills: values.skills,
      experienceYear: Number(values.experience) || 0,
      experienceMonth: Number(values.experienceMonths) || 0,
      // employeeCode: `EMP-${values.clientEmployeeId || ""}`,
      employeeCode: values.clientEmployeeId
        ? `EMP-${values.clientEmployeeId}`
        : "",
      workPermitNumber: values.workPermitNumber,
      workPermitValidDate: values.workPermitValidDate,
      visaNumber: values.visaNumber,
      visaValidDate: values.visaValidityDateTill,
      passportNumber: values.passportNumber,
      passportValidDate: values.passportValidityDateTill,
      emergencyContactName: values.emergencyContactName,
      emergencyContactNumber: removePhoneSpace(values.emergencyContactNumber),
      bankName: values.bankName,
      accountHolderName: values.accountHolderName,
      bankAccountNumber: values.accountNumber,
      branch: values.branch,
      ifsc: values.ifsc,
      upiId: values.upiId,
      ipNumber: values.ipNumber,

      roleId: Number(values.jobrole),
      jobRole: getValueFromList(jobRole, values.jobrole),
      bandId: Number(values.band),
      band: getValueFromList(bands, values.band),
      salary: Number(values.salary),
      assets: assets,
      contractFile: contractFile ? contractFile.name : null,
      contractFileName: contractFile ? contractFile.name : null,
    };

    try {
      const url = isEdit
        ? `${config.API_BASE_URL}${config.UPDATE_EMPLOYEE_ENDPOINT}${employeeId}`
        : `${config.API_BASE_URL}${config.ADD_EMPLOYEE_ENDPOINT}`;

      const method = isEdit ? "PUT" : "POST";

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        const successMsg = isEdit
          ? "Employee updated successfully!"
          : "Employee added successfully!";
        setPopupMessage(successMsg);
        setShowSuccessPopup(true);
        resetForm();

        // Redirect after 1.5 seconds automatically
        setTimeout(() => {
          setShowSuccessPopup(false);
          if (onSuccess) {
            onSuccess();
          } else if (onCancel) {
            onCancel();
          }
          if (fetchEmployees) {
            fetchEmployees();
          }
        }, 1500);
      } else {
        setPopupMessage(
          data.message ||
          `Failed to ${isEdit ? "update" : "add"} employee. Please try again.`
        );
        setShowErrorPopup(true);
      }
    } catch (error) {
      console.error(`Error ${isEdit ? "updating" : "adding"} employee:`, error);
      setPopupMessage("An error occurred. Please try again later.");
      setShowErrorPopup(true);
    } finally {
      setSubmitting(false);
    }
  };
  useEffect(() => {
    const clientId = localStorage.getItem("orgId");
    setSelectedClient(clientId);
    // if (clientId) {
    //   setSelectedClient(clientId);
    // }
  }, []);

  // Synchronize location states when converting from Onboarding
  useEffect(() => {
    if (convertData) {
      if (convertData.country) setSelectedCountry(String(convertData.country));
      if (convertData.state) setSelectedState(String(convertData.state));
    }
  }, [convertData]);

  useEffect(() => {
    const token = localStorage.getItem("Authorization");

    fetch(`${config.API_BASE_URL}${config.COUNTRY_ENDPOINT}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        const countriesList = Array.isArray(data) ? data : (data?.body || data?.data || []);
        setCountries(countriesList);
      })
      .catch((err) => {
        console.error("Country API Error:", err);
      });
  }, []);

  // Fetch states when selectedCountry changes
  useEffect(() => {
    if (!selectedCountry) {
      setStates([]);
      return;
    }
    const token = localStorage.getItem("Authorization");
    fetch(
      `${config.API_BASE_URL}${config.STATE_ENDPOINT}?countryId=${selectedCountry}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        const statesList = Array.isArray(data) ? data : (data?.body || data?.data || []);
        setStates(statesList);
      })
      .catch((err) => {
        console.error("States API Error:", err);
      });
  }, [selectedCountry]);

  // Fetch districts when selectedState changes
  useEffect(() => {
    if (!selectedState) {
      setDistricts([]);
      return;
    }
    const token = localStorage.getItem("Authorization");
    fetch(
      `${config.API_BASE_URL}${config.DISTRICT_ENDPOINT}?stateId=${selectedState}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        const districtsList = Array.isArray(data) ? data : (data?.body || data?.data || []);
        setDistricts(districtsList);
      })
      .catch((err) => {
        console.error("Districts API Error:", err);
      });
  }, [selectedState]);

  useEffect(() => {
    const token = localStorage.getItem("Authorization");
    const orgId = localStorage.getItem("orgId") || "6";

    fetch(`${config.API_BASE_URL}${config.CLIENT_LIST_ENDPOINT}${orgId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setClients(data?.body || data.body || data);
      })
      .catch((err) => {
        console.error("Client API Error:", err);
      });
  }, []);

  // Fetch SubVendors
  useEffect(() => {
    const token = localStorage.getItem("Authorization");
    const orgId = localStorage.getItem("orgId") || "6";

    fetch(
      `${config.API_BASE_URL}${config.SUBVENDOR_LIST_ENDPOINT}?orgKey=${orgId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("SubVendor API:", data);

        const vendors = Array.isArray(data?.body) ? data.body : [];
        setSubVendors(vendors);
      })
      .catch((err) => {
        console.error("SubVendor API Error:", err);
      });
  }, []);

  useEffect(() => {
    if (!selectedClient) return;

    const token = localStorage.getItem("Authorization");
    const orgId = localStorage.getItem("orgId") || "6";
    fetch(
      `${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${orgId}?configType=Qualification`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setQualification(data?.data || data);
        console.log("qualify", data)
      })
      .catch((err) => {
        console.error("Qualification API Error:", err);
      });
  }, [selectedClient]);

  // Fetch Assets config for Separation flow
  useEffect(() => {
    if (!fromSeparation) return;

    const token = localStorage.getItem("Authorization");
    const orgId = localStorage.getItem("orgId") || "6";
    fetch(
      `${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${orgId}?configType=Asset`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setAssetOptions(data?.data || data || []);
      })
      .catch((err) => {
        console.error("Asset API Error:", err);
      });
  }, [fromSeparation]);

  useEffect(() => {
    if (!selectedClient) return;

    const token = localStorage.getItem("Authorization");
    const orgId = localStorage.getItem("orgId") || "6";

    fetch(
      `${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${orgId}?configType=ContractDuration`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setContractDuration(data?.data || data);
      })
      .catch((err) => {
        console.error("ContractDuration API Error:", err);
      });
  }, [selectedClient]);

  useEffect(() => {
    if (!selectedClient) return;

    const token = localStorage.getItem("Authorization");
    const orgId = localStorage.getItem("orgId") || "6";
    fetch(
      `${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${orgId}?configType=JobRole`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setjobrole(data?.data || data);
      })
      .catch((err) => {
        console.error("ShiftType API Error:", err);
      });
  }, [selectedClient]);

  useEffect(() => {
    if (!selectedClient) return;

    const token = localStorage.getItem("Authorization");
    const orgId = localStorage.getItem("orgId") || "6";
    fetch(
      `${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${orgId}?configType=ShiftType`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setShiftTypes(data?.data || data);
      })
      .catch((err) => {
        console.error("ShiftType API Error:", err);
      });
  }, [selectedClient]);

  useEffect(() => {
    if (!selectedClient) return;
    const token = localStorage.getItem("Authorization");
    const orgId = localStorage.getItem("orgId") || "6";
    fetch(
      `${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${orgId}?configType=Department`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log("datass", data)
        setDepartments(data?.data || data); // based on your API structure
      })
      .catch((err) => {
        console.error("Department API Error:", err);
      });
  }, [selectedClient]);

  useEffect(() => {
    if (!selectedClient) return;

    const token = localStorage.getItem("Authorization");
    const orgId = localStorage.getItem("orgId") || "6";
    fetch(
      `${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${orgId}?configType=WorkType`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setWorkTypes(data?.data || data);
      })
      .catch((err) => {
        console.error("WorkType API Error:", err);
      });
  }, [selectedClient]);

  useEffect(() => {
    if (!selectedClient) return;

    const token = localStorage.getItem("Authorization");
    const orgId = localStorage.getItem("orgId") || "6";
    fetch(
      `${config.API_BASE_URL}${config.VIEW_CLIENT_CONFIG_ENDPOINT}${orgId}?configType=Band`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setBands(data?.data || data);
      })
      .catch((err) => {
        console.error("Band API Error:", err);
      });
  }, [selectedClient]);



  return (
    <div>
      {successMessage && (
        <SuccessPopup
          message={successMessage}
          onClose={() => {
            setSuccessMessage(null);
            onCancel();
          }}
        />
      )}
      {errorMessage && (
        <ErrorPopup
          message={errorMessage}
          onClose={() => setErrorMessage(null)}
        />
      )}
      {showConfirmPopup && (
        <ConfirmPopup
          message="Are you sure you want to terminate this employee?"
          onConfirm={handleTerminate}
          onCancel={() => setShowConfirmPopup(false)}
        />
      )}
      {showDeleteConfirmPopup && (
        <ConfirmPopup
          message="Are you sure you want to delete this employee?"
          onConfirm={handleDeleteConfirm}
          onCancel={() => setShowDeleteConfirmPopup(false)}
        />
      )}

      <Header
        showBack={true}
        onBack={onCancel}
        title={
          isViewMode
            ? "View Employee"
            : selectedEmployee
              ? "Edit Employee"
              : "Add Employee"
        }
        subtitle={
          <>
            All Employee <VscChevronRight style={{ verticalAlign: "middle" }} />{" "}
            {isViewMode
              ? "View Employee"
              : selectedEmployee
                ? "Edit Employee"
                : "Add Employee"}
          </>
        }
      />

      <Formik
        enableReinitialize
        innerRef={formikRef}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting, setFieldValue, values }) => (
          <Form className='add-client-form' style={{ marginTop: 0 }}>
            {selectedEmployee && !fromSeparation && (
              <div className='client-form-action-bar'>
                <button
                  type='button'
                  className='client-delete-btn'
                  onClick={handleDelete}
                >
                  <span className='client-delete-icon'>🗑</span>
                  <span>Delete</span>
                </button>
                <button
                  type='button'
                  className='client-edit-btn'
                  onClick={() => setIsViewMode(!isViewMode)}
                >
                  <span className='client-edit-icon'>
                    <LuPencilLine />
                  </span>
                  <span>{isViewMode ? "Edit" : "View"}</span>
                </button>
              </div>
            )}

            {/* Separation Section - Only for Separated Employees */}
            {fromSeparation && employeeDetail && (employeeDetail.status === "InActive" || employeeDetail.terminateExitStatus) && (
              <section className='form-section'>
                <h3>
                  <span className='icon'>
                    <FaUser />
                  </span>{" "}
                  Separation
                </h3>
                <div className='form-grid'>
                  <div className='input-group'>
                    <label>Reason</label>
                    <input
                      type='text'
                      value={employeeDetail.reason || ""}
                      disabled
                    />
                  </div>
                  <div className='input-group'>
                    <label>Separation type</label>
                    <input
                      type='text'
                      value={employeeDetail.terminateExitStatus || ""}
                      disabled
                    />
                  </div>
                  <div className='input-group'>
                    <label>Initiated By</label>
                    <input
                      type='text'
                      value={employeeDetail.terminatedBy || employeeDetail.initiatedBy || ""}
                      disabled
                    />
                  </div>
                  <div className='input-group'>
                    <label>Approved By</label>
                    <input
                      type='text'
                      value={employeeDetail.terminatedBy || employeeDetail.initiatedBy || ""}
                      disabled
                    />
                  </div>
                  <div className='input-group'>
                    <label>Notice Period</label>
                    <input
                      type='text'
                      value={employeeDetail.noticePeriod || ""}
                      disabled
                    />
                  </div>
                </div>
              </section>
            )}

            {/* Personal Information Section */}
            <section className='form-section'>
              <h3>
                <span className='icon'>
                  <FaUser />
                </span>{" "}
                Personal Information
              </h3>
              <div className='form-grid'>
                <div className='input-group'>
                  <label>Employee Name <span className="required-star">*</span></label>
                  <Field
                    type='text'
                    name='employeeName'
                    disabled={isViewMode}
                  />
                  <ErrorMessage
                    name='employeeName'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>Date of Birth <span className="required-star">*</span></label>

                  <DatePicker
                    selected={parseDate(values.dob)}
                    onChange={(date) => {
                      setFieldValue("dob", formatDate(date));
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="dd-mm-yyyy"
                    disabled={isViewMode}
                    autoComplete="off"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                  <ErrorMessage name='dob' component='div' className='error' />
                </div>
                <div className='input-group'>
                  <label>
                    Client Employee ID <span className="required-star">*</span>
                  </label>
                  <Field
                    type='text'
                    name='clientEmployeeId'
                    disabled={isViewMode}
                  />
                  <ErrorMessage
                    name='clientEmployeeId'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>Phone Number <span className="required-star">*</span></label>

                  <Field
                    type='text'
                    name='phoneNumber'
                    disabled={isViewMode}
                    onChange={(e) => {
                      if (isViewMode) return;
                      let value = e.target.value;

                      // Automatically add +91 if not present
                      if (!value.startsWith("+91 ")) {
                        value = "+91 " + value.slice(4); // Ensure it starts with +91
                      }

                      // Restrict to 14 characters (including +91)
                      if (value.length > 12) {
                        value = value.slice(0, 14); // Limit the input to 14 characters
                      }

                      setFieldValue("phoneNumber", value); // Update field value
                    }}
                  />
                  <ErrorMessage
                    name='phoneNumber'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>
                    Email Address <span className='required-asterisk'>*</span>
                  </label>
                  <Field
                    type='email'
                    name='emailAddress'
                    disabled={isViewMode}
                    placeholder=''
                    onChange={(e) => {
                      if (isViewMode) return;
                      setFieldValue("emailAddress", e.target.value.toLowerCase());
                    }}
                  />
                  <ErrorMessage
                    name='emailAddress'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>Marital Status</label>
                  <Field
                    as='select'
                    name='maritalStatus'
                    required
                    disabled={isViewMode}
                  >
                    <option value=''>Select</option>
                    <option value='Single'>Single</option>
                    <option value='Married'>Married</option>
                    <option value='Divorced'>Divorced</option>
                    <option value='Widowed'>Widowed</option>
                  </Field>
                  

                  <ErrorMessage
                    name='maritalStatus'
                    component='div'
                    className='error'
                  />
                </div>

                <div className='input-group'>
                  <label>Aadhar Number <span className="required-star">*</span></label>
                  <Field
                    type='text'
                    name='aadharNumber'
                    disabled={isViewMode}
                  />
                  <ErrorMessage
                    name='aadharNumber'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>UAN Number <span className="required-star">*</span></label>
                  <Field type='text' name='uanNumber' disabled={isViewMode} />
                  <ErrorMessage
                    name='uanNumber'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>Gender <span className="required-star">*</span></label>
                  <Field
                    as='select'
                    name='gender'
                    required
                    disabled={isViewMode}
                  >
                    <option value=''>Select</option>
                    <option value='MALE'>Male</option>
                    <option value='FEMALE'>Female</option>
                    <option value='OTHER'>Other</option>
                  </Field>
                  
                  <ErrorMessage
                    name='gender'
                    component='div'
                    className='error'
                  />
                </div>

                <div className='input-group'>
                  <label>Address <span className="required-star">*</span></label>

                  <Field type='text' name='address' disabled={isViewMode} />
                  <ErrorMessage
                    name='address'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>City <span className="required-star">*</span></label>

                  <Field type='text' name='city' disabled={isViewMode} />
                  <ErrorMessage name='city' component='div' className='error' />
                </div>
                <div className='input-group'>
                  <label>PIN Code <span className="required-star">*</span></label>

                  <Field type='text' name='pinCode' disabled={isViewMode} />
                  <ErrorMessage
                    name='pinCode'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>Country <span className="required-star">*</span></label>

                  <Field
                    as='select'
                    name='country'
                    required
                    disabled={isViewMode}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFieldValue("country", value);
                      setSelectedCountry(value);
                      setFieldValue("state", "");
                      setFieldValue("district", "");
                      setStates([]);
                      setDistricts([]);
                    }}
                  >
                    <option value=''>Select</option>
                    {Array.isArray(countries) && countries.map((country, index) => (
                      <option key={index} value={country.id || country.countryId}>
                        {country.countryName || country.name}
                      </option>
                    ))}
                  </Field>
                  
                  <ErrorMessage
                    name='country'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>State <span className="required-star">*</span></label>

                  <Field
                    as='select'
                    name='state'
                    required
                    disabled={isViewMode}
                    onChange={(e) => {
                      const value = e.target.value;
                      setFieldValue("state", value);
                      setSelectedState(value);
                      setFieldValue("district", "");
                      setDistricts([]);
                    }}
                  >
                    <option value=''>Select</option>
                    {Array.isArray(states) && states.map((s, index) => (
                      <option key={index} value={s.id || s.stateId}>
                        {s.countryName || s.stateName || s.name}
                      </option>
                    ))}
                  </Field>
                  
                  <ErrorMessage
                    name='state'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>District <span className="required-star">*</span></label>

                  <Field
                    as='select'
                    name='district'
                    required
                    disabled={isViewMode}
                  >
                    <option value=''>Select</option>
                    {Array.isArray(districts) && districts.map((d, index) => (
                      <option key={index} value={d.id || d.districtId}>
                        {d.countryName || d.districtName || d.name}
                      </option>
                    ))}
                  </Field>
                  
                  <ErrorMessage
                    name='district'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>Shift Type <span className="required-star">*</span></label>
                  <Field
                    as='select'
                    name='shiftType'
                    required
                    disabled={isViewMode}
                  >
                    <option value=''>Select</option>

                    {shiftTypes.map((st, index) => (
                      <option key={index} value={st.values}>
                        {st.values}
                      </option>
                    ))}
                  </Field>
                  
                  <ErrorMessage
                    name='shiftType'
                    component='div'
                    className='error'
                  />
                </div>

                <div className='input-group'>
                  <label>Shift Timing <span className="required-star">*</span></label>
                  <Field
                    as='select'
                    name='shiftTiming'
                    required
                    disabled={isViewMode}
                  >
                    <option value=''>Select</option>

                    {shiftTimings.map((st, index) => (
                      <option key={index} value={st.values}>
                        {st.values}
                      </option>
                    ))}
                  </Field>
                  
                  <ErrorMessage
                    name='shiftTiming'
                    component='div'
                    className='error'
                  />
                </div>
              </div>
            </section>

            {/* Employment Information Section */}
            <section className='form-section'>
              <h3>
                <span className='icon'>
                  <FaUser />
                </span>{" "}
                Employment Information
              </h3>
              <div className='form-grid'>
                <div className='input-group'>
                  <label>Client <span className="required-star">*</span></label>
                  <Field
                    as='select'
                    name='client'
                    required
                    disabled={isViewMode}
                  >
                    <option value=''>Select</option>

                    {clients.map((client, index) => (
                      <option key={index} value={client.clientKey}>
                        {client.name}
                      </option>
                    ))}
                  </Field>
                  

                  <ErrorMessage
                    name='client'
                    component='div'
                    className='error'
                  />
                </div>

                <div className='input-group'>
                  <label>Sub Vendor <span className="required-star">*</span></label>
                  <Field as='select' name='subVendor' disabled={isViewMode}>
                    <option value=''>Select</option>
                    {subVendors.map((vendor, index) => (
                      <option
                        key={index}
                        value={vendor.subVendorName || vendor.name}
                      >
                        {vendor.subVendorName || vendor.name}
                      </option>
                    ))}
                  </Field>
                  
                  <ErrorMessage
                    name='subVendor'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>JobRole <span className="required-star">*</span></label>
                  <Field
                    as='select'
                    name='jobRole'
                    required
                    disabled={isViewMode}
                  >
                    <option value=''>Select</option>

                    {jobRole.map((st, index) => (
                      <option key={index} value={st.values}>
                        {st.values}
                      </option>
                    ))}
                  </Field>
                  
                  <ErrorMessage
                    name='jobRole'
                    component='div'
                    className='error'
                  />
                </div>
                {/* <div className='input-group'>
                  <label>Job Role</label>
                  <Field as='select' name='jobRole'>
                    <option value=''>Select</option>
                  </Field>
                  
                  <ErrorMessage
                    name='jobRole'
                    component='div'
                    className='error'
                  />
                </div> */}
                <div className='input-group'>
                  <label>Work Site <span className="required-star">*</span></label>
                  <Field type='text' name='workSite' disabled={isViewMode} />
                  <ErrorMessage
                    name='workSite'
                    component='div'
                    className='error'
                  />
                </div>
                {/* <div className='input-group'>
                  <label>Department</label>
                  <Field as='select' name='department'>
                    <option value=''>Select</option>
                  </Field>
                  
                  <ErrorMessage
                    name='department'
                    component='div'
                    className='error'
                  />
                </div> */}
                <div className='input-group'>
                  <label>Department <span className="required-star">*</span></label>
                  <Field as='select' name='department' disabled={isViewMode}>
                    <option value=''>Select</option>

                    {departments.map((dept, index) => (
                      <option key={index} value={dept.id}>
                        {dept.values}
                      </option>
                    ))}
                  </Field>
                  
                  <ErrorMessage
                    name='department'
                    component='div'
                    className='error'
                  />
                </div>

                <div className='input-group'>
                  <label>Date of Joining <span className="required-star">*</span></label>
                  <DatePicker
                    selected={parseDate(values.dateOfJoining)}
                    onChange={(date) => {
                      setFieldValue("dateOfJoining", formatDate(date));
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="dd-mm-yyyy"
                    minDate={new Date()}
                    disabled={isViewMode}
                    autoComplete="off"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                  <ErrorMessage
                    name='dateOfJoining'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>Work Type <span className="required-star">*</span></label>
                  <Field as='select' name='workType' disabled={isViewMode}>
                    <option value=''>Select</option>

                    {workTypes.map((wt, index) => (
                      <option key={index} value={wt.values}>
                        {wt.values}
                      </option>
                    ))}
                  </Field>
                  
                  <ErrorMessage
                    name='workType'
                    component='div'
                    className='error'
                  />
                </div>

                <div className='input-group'>
                  <label>Qualification <span className="required-star">*</span></label>
                  <Field
                    as='select'
                    name='qualification'
                    required
                    disabled={isViewMode}
                  >
                    <option value=''>Select</option>

                    {qualification.map((q, index) => (
                      <option key={index} value={q.values}>
                        {q.values}
                      </option>
                    ))}
                  </Field>
                  

                  <ErrorMessage
                    name='qualification'
                    component='div'
                    className='error'
                  />
                </div>

                <div className='input-group'>
                  <label>Skills <span className="required-star">*</span></label>
                  <Field type='text' name='skills' disabled={isViewMode} />
                  <ErrorMessage
                    name='skills'
                    component='div'
                    className='error'
                  />
                </div>


                <div className='input-group'>
                  <label>Experience</label>
                  <div style={{ display: "flex", gap: "10px" }}>
                    <Field type='text' name='experience' placeholder='Years' />
                    <Field
                      type='text'
                      name='experienceMonths'
                      placeholder='Months'
                    />
                  </div>
                  <ErrorMessage
                    name='experience'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>Contract Duration <span className="required-star">*</span></label>
                  <Field
                    as='select'
                    name='contractDuration'
                    required
                    disabled={isViewMode}
                  >
                    <option value=''>Select</option>

                    {contractDuration.map((cd, index) => (
                      <option key={index} value={cd.values}>
                        {cd.values}
                      </option>
                    ))}
                  </Field>
                  

                  <ErrorMessage
                    name='contractDuration'
                    component='div'
                    className='error'
                  />
                </div>

                <div className='input-group' style={{ display: 'flex', flexDirection: 'column' }}>
                  <label style={{marginLeft:"32px"}}>Contract File / Document</label>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginTop: '10px',marginLeft:"32px" }}>
                    <span style={{ fontSize: '13px', color: '#6b7280' }}>
                      Drag & Drop or <span style={{ color: '#26A4FF', cursor: 'pointer' }} onClick={() => !isViewMode && document.getElementById('contract-file-upload').click()}>choose file</span> to upload
                    </span>
                    <button 
                      type="button" 
                      onClick={() => !isViewMode && document.getElementById('contract-file-upload').click()}
                      style={{ 
                        background: '#26A4FF', 
                        border: 'none', 
                        borderRadius: '10px', 
                        width: '40px', 
                        height: '40px', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        color: 'white',
                        cursor: isViewMode ? 'not-allowed' : 'pointer',
                        opacity: isViewMode ? 0.6 : 1
                      }}
                    >
                      <LuUpload size={20} />
                    </button>
                    <input
                      id="contract-file-upload"
                      type="file"
                      style={{ display: 'none' }}
                      onChange={(e) => {
                        const file = e.target.files[0];
                        if (file) setContractFile(file);
                      }}
                      disabled={isViewMode}
                    />
                  </div>
                  {contractFile && (
                    <span style={{ fontSize: '12px', color: '#10b981', marginTop: '8px' }}>{contractFile.name} selected</span>
                  )}
                </div>
              </div>
            </section>

            {/* Work & Compliance Section */}
            <section className='form-section'>
              <h3>
                <span className='icon'>
                  <FaUser />
                </span>{" "}
                Work & Compliance
              </h3>
              <div className='form-grid'>
                <div className='input-group'>
                  <label>Work Permit Number</label>
                  <Field
                    type='text'
                    name='workPermitNumber'
                    disabled={isViewMode}
                  />
                  <ErrorMessage
                    name='workPermitNumber'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>Work Permit Valid Date</label>
                  <DatePicker
                    selected={parseDate(values.workPermitValidDate)}
                    onChange={(date) => {
                      setFieldValue("workPermitValidDate", formatDate(date));
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="dd-mm-yyyy"
                    minDate={new Date()}
                    disabled={isViewMode}
                    autoComplete="off"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                  <ErrorMessage
                    name='workPermitValidDate'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>Visa Number</label>
                  <Field type='text' name='visaNumber' disabled={isViewMode} />
                  <ErrorMessage
                    name='visaNumber'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>Visa Validity Date Till</label>
                  <DatePicker
                    selected={parseDate(values.visaValidityDateTill)}
                    onChange={(date) => {
                      setFieldValue("visaValidityDateTill", formatDate(date));
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="dd-mm-yyyy"
                    minDate={new Date()}
                    disabled={isViewMode}
                    autoComplete="off"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                  <ErrorMessage
                    name='visaValidityDateTill'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>Passport Number</label>
                  <Field
                    type='text'
                    name='passportNumber'
                    disabled={isViewMode}
                  />
                  <ErrorMessage
                    name='passportNumber'
                    component='div'
                    className='error'
                  />
                </div>
                <div className='input-group'>
                  <label>Passport Validity Date Till</label>
                  <DatePicker
                    selected={parseDate(values.passportValidityDateTill)}
                    onChange={(date) => {
                      setFieldValue("passportValidityDateTill", formatDate(date));
                    }}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="dd-mm-yyyy"
                    minDate={new Date()}
                    disabled={isViewMode}
                    autoComplete="off"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                  <ErrorMessage
                    name='passportValidityDateTill'
                    component='div'
                    className='error'
                  />
                </div>
              </div>
            </section>

            {/* Emergency Contact Section */}
            <section className='form-section'>
              <h3>
                <span className='icon'>
                  <FaUser />
                </span>{" "}
                Emergency Contact
              </h3>

              <div className='form-grid'>
                <div className='input-group'>
                  <label>
                    Emergency Contact Name <span className="required-star">*</span>
                  </label>
                  <Field
                    type='text'
                    name='emergencyContactName'
                    disabled={isViewMode}
                  />
                  <ErrorMessage
                    name='emergencyContactName'
                    component='div'
                    className='error'
                  />
                </div>

                <div className='input-group'>
                  <label>
                    Emergency Contact Number <span className="required-star">*</span>
                  </label>
                  <Field
                    type='text'
                    name='emergencyContactNumber'
                    disabled={isViewMode}
                    onChange={(e) => {
                      if (isViewMode) return;
                      let value = e.target.value;

                      if (!value.startsWith("+91 ")) {
                        value = "+91 " + value.slice(4);
                      }

                      if (value.length > 14) {
                        value = value.slice(0, 14);
                      }

                      setFieldValue("emergencyContactNumber", value);
                    }}
                  />
                  <ErrorMessage
                    name='emergencyContactNumber'
                    component='div'
                    className='error'
                  />
                </div>
              </div>
            </section>

            <section className='form-section'>
              <h3>
                <span className='icon'>
                  <FaUser />
                </span>{" "}
                Bank Details
              </h3>

              <div className='form-grid'>
                <div className='input-group'>
                  <label>
                    Bank Name <span className="required-star">*</span>
                  </label>
                  <Field
                    as='select'
                    name='bankName'
                    required
                    disabled={isViewMode}
                  >
                    <option value=''>Select Bank</option>
                    {BANK_LIST.map((bank, index) => (
                      <option key={index} value={bank}>
                        {bank}
                      </option>
                    ))}
                  </Field>
                  
                  <ErrorMessage name='bankName' component='div' className='error' />
                </div>

                <div className='input-group'>
                  <label>
                    Account Holder Name <span className="required-star">*</span>
                  </label>
                  <Field
                    type='text'
                    name='accountHolderName'
                    disabled={isViewMode}
                  />
                  <ErrorMessage
                    name='accountHolderName'
                    component='div'
                    className='error'
                  />
                </div>

                <div className='input-group'>
                  <label>
                    Account Number <span className="required-star">*</span>
                  </label>
                  <Field
                    type='text'
                    name='accountNumber'
                    disabled={isViewMode}
                  />
                  <ErrorMessage
                    name='accountNumber'
                    component='div'
                    className='error'
                  />
                </div>

                <div className='input-group'>
                  <label>
                    Branch <span className="required-star">*</span>
                  </label>
                  <Field type='text' name='branch' disabled={isViewMode} />
                  <ErrorMessage name='branch' component='div' className='error' />
                </div>

                <div className='input-group'>
                  <label>
                    IFSC <span className="required-star">*</span>
                  </label>
                  <Field type='text' name='ifsc' disabled={isViewMode} />
                  <ErrorMessage name='ifsc' component='div' className='error' />
                </div>

                <div className='input-group'>
                  <label>
                    UPI ID <span className="required-star">*</span>
                  </label>
                  <Field type='text' name='upiId' disabled={isViewMode} />
                  <ErrorMessage name='upiId' component='div' className='error' />
                </div>

                <div className='input-group'>
                  <label>IP Number</label>
                  <Field type='text' name='ipNumber' disabled={isViewMode} />
                  <ErrorMessage name='ipNumber' component='div' className='error' />
                </div>
              </div>
            </section>

            <section className='form-section'>
              <h3>
                <span className='icon'>
                  <FaUser />
                </span>{" "}
                Salary Details
              </h3>

              <div className='form-grid'>
                <div className='input-group'>
                  <label>
                    Job Role <span className="required-star">*</span>
                  </label>
                  <Field
                    as='select'
                    name='jobrole'
                    required
                    disabled={isViewMode}
                  >
                    <option value=''>Select</option>
                    {jobRole.map((jr, index) => (
                      <option key={index} value={jr.id}>
                        {jr.values}
                      </option>
                    ))}
                  </Field>
                  
                  <ErrorMessage
                    name='jobrole'
                    component='div'
                    className='error'
                  />
                </div>

                <div className='input-group'>
                  <label>
                    Band <span className="required-star">*</span>
                  </label>
                  <Field
                    as='select'
                    name='band'
                    disabled={isViewMode}
                  >
                    <option value=''>Select</option>
                    {bands.map((b, index) => (
                      <option key={index} value={b.id}>
                        {b.values}
                      </option>
                    ))}
                  </Field>
                  
                  <ErrorMessage
                    name='band'
                    component='div'
                    className='error'
                  />
                </div>
              </div>
            </section>

            {/* Assets Section */}
            <section className='form-section'>
              <h3>
                <span className='icon'><FaUser /></span>{" "}
                Assets
              </h3>

              {!fromSeparation && (
                <div className='form-grid' style={{ marginBottom: "16px" }}>
                  <div className='input-group'>
                    <label>Asset Name</label>
                    <select
                      value=""
                      onChange={(e) => {
                        const val = e.target.value;
                        if (val && !assets.includes(val)) {
                          setAssets((prev) => [...prev, val]);
                        }
                      }}
                      disabled={isViewMode}
                    >
                      <option value="" disabled>Select Asset...</option>
                      {Array.isArray(assetOptions) && assetOptions.map((opt, idx) => (
                        <option key={idx} value={opt.values} disabled={assets.includes(opt.values)}>
                          {opt.values}
                        </option>
                      ))}
                    </select>
                    
                  </div>
                </div>
              )}

              <div className='input-group'>
                <label>Assets</label>
                <div
                  style={{
                    border: "1px solid #e0e0e0",
                    borderRadius: "8px",
                    padding: "10px 12px",
                    minHeight: "60px",
                    background: "#fff",
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                    alignItems: "flex-start",
                  }}
                >
                  {assets.map((asset, i) => (
                    <span
                      key={i}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        background: "#232d5c",
                        color: "#fff",
                        borderRadius: "20px",
                        padding: "4px 12px",
                        fontSize: "12px",
                        fontWeight: 500,
                      }}
                    >
                      {asset}
                      <button
                        type='button'
                        onClick={() => setAssets((prev) => prev.filter((_, idx) => idx !== i))}
                        style={{
                          background: "none",
                          border: "none",
                          color: "#fff",
                          cursor: "pointer",
                          fontSize: "14px",
                          lineHeight: 1,
                          padding: 0,
                        }}
                      >
                        ×
                      </button>
                    </span>
                  ))}
                  {assets.length === 0 && (
                    <span style={{ color: "#999", fontSize: "14px" }}>
                      No assets selected
                    </span>
                  )}
                </div>
              </div>
            </section>

            {/* Action Buttons */}
            {fromSeparation ? (
              // Separation context: Terminate (left) + Exit (right), no Cancel/Save
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px", paddingTop: "20px", borderTop: "1px solid #f0f0f0" }}>
                <button
                  type='button'
                  onClick={() => setShowTerminateModal(true)}
                  style={{ background: "#dc2626", color: "#fff", border: "none", borderRadius: "10px", padding: "11px 32px", fontSize: "14px", fontWeight: 600, cursor: "pointer" }}
                >
                  Terminate
                </button>
                <button
                  type='button'
                  onClick={() => setShowExitModal(true)}
                  style={{ background: "#dc2626", color: "#fff", width: "12%", border: "none", borderRadius: "10px", padding: "11px 32px", fontSize: "14px", fontWeight: 600, cursor: "pointer" }}
                >
                  Resign
                </button>
              </div>
            ) : (
              <div className='form-actions'>
                <div className='client-cancel-button-container'>
                  <button type='button' className='cancel-btn' onClick={onCancel}>
                    Cancel
                  </button>
                </div>
                <button
                  type='submit'
                  className='save-btn'
                  disabled={isSubmitting || isViewMode}
                >
                  {isSubmitting
                    ? selectedEmployee
                      ? "Updating..."
                      : "Saving..."
                    : selectedEmployee
                      ? "Update Emp"
                      : "Add"}
                </button>
              </div>
            )}
          </Form>
        )}
      </Formik>

      {showSuccessPopup && (
        <SuccessPopup
          message={popupMessage}
          onClose={() => {
            setShowSuccessPopup(false);
            if (onSuccess) {
              onSuccess();
            } else if (onCancel) {
              onCancel();
            }
            if (fetchEmployees) {
              fetchEmployees();
            }
          }}
        />
      )}

      {showErrorPopup && (
        <ErrorPopup
          message={popupMessage}
          onClose={() => setShowErrorPopup(false)}
        />
      )}

      {/* Separation popups */}
      {showTerminateModal && (
        <TerminationPopup
          employee={selectedEmployee}
          assets={assets}
          onClose={() => setShowTerminateModal(false)}
          onSuccess={() => {
            setShowTerminateModal(false);
            onCancel && onCancel();
          }}
        />
      )}

      {showExitModal && (
        <ExitPopup
          employee={selectedEmployee}
          assets={assets}
          onClose={() => setShowExitModal(false)}
          onSuccess={() => {
            setShowExitModal(false);
            onCancel && onCancel();
          }}
        />
      )}
    </div>
  );
};

export default AddEmployee;
